<template>
  <div class="home">
    <div class="col-3 row">
      <div class="rol-3 logo">
        <img src="../assets/images/logo.png" alt="理想城社区" />
      </div>
      <router-link class="rol-3 about" tag="div" to="/about">
        <img src="../assets/images/about.jpg" alt />
        <h2>社区简介</h2>
      </router-link>
      <div class="rol-3 row-c">
        <router-link class="col-5 culture" to="/culture/culture" tag="div">
          <h2>社区文化</h2>
        </router-link>
        <router-link class="col-5 character" to="/character" tag="div">
          <h2>社区特色</h2>
        </router-link>
      </div>
    </div>
    <div class="col-3 row" >
      <div class="rol-6 activity">
        <h2>主题党日活动</h2>
        <router-link  class="more" to="/party/activity"></router-link>
        <ul class="list" v-if='swiperSlides.length>0'>
          <router-link :to='"/party/activity/"+first.id' tag="li" class="list-item">
            <span class="news-date">
              <i>{{first.day}}</i> {{first.year}}-{{first.month}}
            </span>
            <div class="news">
              <h3 class="news-title">{{first.title}}</h3>
              <p class="news-content">{{first.content}}</p>
            </div>
          </router-link>
          <li class="list-item" v-for="(item,i) in list" :key="i">
            <router-link :to='"/party/activity/"+item.id' tag="h3"><p class="p">{{item.month+'/'+item.day}} {{item.content}}</p></router-link>
          </li>
          <!-- <li class="list-item">
            <h3>09/11</h3>
          </li>
          <li class="list-item">
            <h3>09/11 理想城社区10党日活动在10</h3>
          </li>
          <li class="list-item">
            <h3>09/11</h3>
          </li> -->
        </ul>
      </div>
      <router-link class="rol-3 service" to="/service" tag="div">
        <h2>便民服务</h2>
      </router-link>
    </div>
    <div class="col-3 row">
      <div class="rol-3 date">
        <p>{{date.hour +':'+ date.minute +':'+ date.second}}{{date.week}}</p>
        <p>{{date.year}}年{{date.month}}月{{date.day}}日</p>
        <iframe
          scrolling="no"
          src="https://tianqiapi.com/api.php?style=tg&skin=sogou"
          frameborder="0"
          width="470"
          height="60"
          allowtransparency="true"
        ></iframe>
      </div>
      <router-link class="rol-3 party" to="/party" tag="div">
        <h2>社区党建</h2>
      </router-link>
      <div class="rol-3 row">
        <router-link class="rol-5 security" to="/security" tag="div">
          <h2>社区安全</h2>
        </router-link>
        <router-link class="rol-5 volunteer" to="/family" tag="div">
          <h2>家园志愿</h2>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleList } from "../api/index";
export default {
  data() {
    return {
      date: {
        year: "",
        day: "",
        month: "",
        week: "",
        hour: "",
        minute: "",
        second: "",
      },
      action:'activity',
      swiperSlides:[],
      list:[],
      first:[]
    };
  },
  methods: {
    getDate() {
      let { date } = this;
      let mydate = new Date();
      let weekend = [
        "星期天",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ];
      date.year = mydate.getFullYear();
      date.month =
        mydate.getMonth() + 1 > 10
          ? mydate.getMonth() + 1
          : "0" + (mydate.getMonth() + 1);
      date.day =
        mydate.getDate() > 10 ? mydate.getDate() : "0" + mydate.getDate();
      var nowday = mydate.getDay();
      date.week = weekend[nowday];
      date.hour = mydate.getHours();
      date.minute =
        mydate.getMinutes() > 10
          ? mydate.getMinutes()
          : "0" + mydate.getMinutes();
      date.second =
        mydate.getSeconds() > 10
          ? mydate.getSeconds()
          : "0" + mydate.getSeconds();
    },
    async getList() {
      let { data } = await getArticleList({ action:'activity' });
      let reg = /<\/?.+?\/?>/g;
     
      this.swiperSlides=data.data
       this.swiperSlides=this.swiperSlides.filter( (item,i)=>{
         return i<=4
       } )
      this.swiperSlides.forEach(item => {
        item.content = item.content.replace(reg, "");
     
        item['month'] = new Date(item.create_time*1000).getMonth()+1
        item["day"] = new Date(item.create_time*1000).getDate()
        item["year"] = new Date(item.create_time*1000).getFullYear()
      });

      this.list = this.swiperSlides
      this.first = this.list.shift()
      
    }
  },
  created() {
    this.getList()
    this.getDate();
    setInterval(this.getDate, 1000);
  }
};
</script>

<style>
</style>